/* Insane Rarity — theme interactions */
document.addEventListener('click', function(e){
  var t = e.target.closest('[data-nav-toggle]');
  if(t){ var m=document.querySelector('[data-mobile-menu]'); if(m) m.classList.toggle('open'); }
  var h = e.target.closest('.acc-head');
  if(h){ var b=h.nextElementSibling; var open=b.style.display==='block'; b.style.display=open?'none':'block'; var p=h.querySelector('.plus'); if(p) p.textContent=open?'+':'–'; }
  var th = e.target.closest('.thumb');
  if(th){ document.querySelectorAll('.thumb').forEach(function(x){x.classList.remove('active');}); th.classList.add('active');
    var main=document.getElementById('mainImg'); var full=th.getAttribute('data-full'); if(main&&full) main.src=full; }
});
document.querySelectorAll('.qty').forEach(function(q){
  var i=q.querySelector('input'), b=q.querySelectorAll('button');
  if(!i||b.length<2) return;
  b[0].addEventListener('click',function(){ i.value=Math.max(1,(parseInt(i.value,10)||1)-1); i.dispatchEvent(new Event('change',{bubbles:true})); });
  b[1].addEventListener('click',function(){ i.value=(parseInt(i.value,10)||1)+1; i.dispatchEvent(new Event('change',{bubbles:true})); });
});
document.querySelectorAll('.acc-body').forEach(function(b){ b.style.display='none'; });
(function(){
  var form=document.querySelector('[data-product-form]');
  if(!form) return;
  var data=window.__IRVariants||[];
  var idField=form.querySelector('[name="id"]');
  function selected(){
    var opts=[].map.call(form.querySelectorAll('[data-opt]'),function(s){return s.value;});
    return data.find(function(v){ return v.options.join('~~')===opts.join('~~'); });
  }
  form.querySelectorAll('[data-opt]').forEach(function(s){
    s.addEventListener('change',function(){
      var v=selected(); if(!v) return;
      if(idField) idField.value=v.id;
      var price=document.querySelector('[data-price]'); if(price) price.textContent=v.price;
      var atc=form.querySelector('[data-atc]');
      if(atc){ atc.disabled=!v.available; atc.textContent=v.available?('Add to Cart — '+v.price):'Sold Out'; }
    });
  });
})();
